import React, {Component} from 'react'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton
} from 'reactstrap'

class Page500 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <span className="clearfix">
                <h1 className="float-left display-3 mr-4">500</h1>
                <h4 className="pt-3">WIR BAUEN UM</h4>
                <p className="text-muted float-left">Entschuldigen Sie bitte die Unterbrechung, wir sind bald wieder da.</p>
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Page500



// WEBPACK FOOTER //
// ./src/views/Pages/Page500/Page500.js